export default "__VITE_ASSET__Dci2wF1F__"